<script setup lang="ts">
import { cn } from '@/lib/utils'
import { ChevronRight } from 'lucide-vue-next'
import {
  DropdownMenuSubTrigger,
  type DropdownMenuSubTriggerProps,
  useForwardProps,
} from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'
import { menuItemFocusRing } from './focus-ring'

const props = defineProps<DropdownMenuSubTriggerProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <DropdownMenuSubTrigger
    v-bind="forwardedProps"
    :class="cn(
      'flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-md outline-none focus:bg-accent data-[state=open]:bg-accent',
      menuItemFocusRing,
      props.class,
    )"
  >
    <slot />
    <slot name="icon"><ChevronRight class="ml-auto h-4 w-4" aria-hidden="true" /></slot>
  </DropdownMenuSubTrigger>
</template>
